module.exports = __webpack_public_path__ + "static/media/icon-microphone-stop.270c778d.svg";